import {
  APIInfrastructureProvider,
  APIInfrastructureProviderAccount,
} from "@/typesAPI";
import API from "@/api/wrapper";

type State = {
  providerList: APIInfrastructureProvider[] | null;
  accountList: APIInfrastructureProviderAccount[] | null;
};

const state: State = {
  providerList: null,
  accountList: null,
};

let loading = false;

const getters = {
  getAccountList: (state: State): APIInfrastructureProviderAccount[] => {
    if (state.accountList === null && !loading) {
      loading = true;
      API.infrastructureProviderAccounts
        .getAccounts()
        .then((res: APIInfrastructureProviderAccount[]) => {
          state.accountList = res;
        })
        .catch(() => {
          state.accountList = [];
        })
        .finally(() => {
          loading = false;
        });
    }
    return state.accountList ?? [];
  },
};

const mutations = {
  DELETE_ACCOUNT: (state: State, id: string) => {
    state.accountList = state.accountList
      ? state.accountList.filter((account) => account.id !== id)
      : null;
  },
  EDIT_ACCOUNT: (state: State, account: APIInfrastructureProviderAccount) => {
    state.accountList = state.accountList
      ? state.accountList.map((storedAccount) =>
          storedAccount.id === account.id ? account : storedAccount,
        )
      : null;
  },
  CREATE_ACCOUNT: (state: State, account: APIInfrastructureProviderAccount) => {
    state.accountList = state.accountList
      ? [...state.accountList, account]
      : [account];
  },
};

const actions = {
  deleteAccount: (context: any, id: string) => {
    API.infrastructureProviderAccounts.delete(id).then(() => {
      context.commit("DELETE_ACCOUNT", id);
    });
  },
  editAccount: (context: any, payload: { accountId: string; body: any }) => {
    API.infrastructureProviderAccounts
      .edit(payload.accountId, payload.body)
      .then((res: APIInfrastructureProviderAccount) => {
        context.commit("EDIT_ACCOUNT", res);
      });
  },
  createAccount: (
    context: any,
    payload: { providerId: string; body: any },
  ) => {
    API.infrastructureProviderAccounts
      .create(payload.providerId, payload.body)
      .then((res: APIInfrastructureProviderAccount) => {
        context.commit("CREATE_ACCOUNT", res);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
